import { useState, useEffect } from 'react'
import { getSubscription, ApiError } from '../lib/api'
import type { SubscriptionResponse } from '../types/models'

export function useSubscription() {
  const [subscription, setSubscription] = useState<SubscriptionResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      setSubscription(await getSubscription())
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load subscription')
    } finally {
      setLoading(false)
    }
  }

  // setState only in async continuations (react-hooks/set-state-in-effect). `loading` starts true.
  useEffect(() => {
    let cancelled = false
    getSubscription()
      .then((s) => { if (!cancelled) setSubscription(s) })
      .catch((e) => { if (!cancelled) setError(e instanceof ApiError ? e.message : 'Failed to load subscription') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { subscription, loading, error, refresh: load }
}
